var exports = {
  "kL": "ReportFlowScreenView.module__container___SHg5ST",
  "uW": "ReportFlowScreenView.module__section___SHg5ST",
  "R_": "ReportFlowScreenView.module__heading___SHg5ST",
};

module.exports = exports;
